(function (angular) {
    'use strict';

    angular.module('twitter')
        /**
         *
         */
        .controller('TwitterCtrl',
        ['$scope', '$rootScope', 'twitterServices', 'twitterData', '$stateParams', '$state', 'growlService', '$uibModalInstance',
            function ($scope, $rootScope, twitterServices, twitterData, $stateParams, $state, growlService, $uibModalInstance) {
                    $scope.twitterData = twitterData || {};
                    $scope.cancelTwitterUpdate = function(){
                        $uibModalInstance.dismiss('cancel');
                    };
                
                    $scope.updateTwitter = function(){
                        var data = {
                            appName: twitterData.appName ? twitterData.appName : 'twitter-' + $stateParams.pickedApiSpaceId,
                            authConfiguration: $scope.twitterData.authConfiguration,
                            environment: $scope.twitterData.environment
                        };
                        twitterServices.setTwitterDetails($stateParams.pickedApiSpaceId, data)
                        .then(function(config){
                            growlService.success('Twitter Config set');
                            $rootScope.$broadcast('Twitter channel configured');
                            $uibModalInstance.close('save');
                        }).catch(function(error){
                            growlService.danger("Twitter Config wasn't set due to: "+error.statusText);
                        });

                    };
        }]);


})(window.angular);
